import { useEffect, useState } from "react";
interface ToggleProps {
  register?: any;
  errors?: any;
  name?: string;
  required?: boolean;
  labelName?: string;
  defaultChecked?: any;
  tabIndex?: number;
  handleDisplayModal?: any;
  setChecked?: any;
  setShowClickedSerial?: any;
  setShowSerialToggle?: any;
  modalSubmit?: any;
  showClickedSerial?: any;
  setModalSubmit?: any;
  displayModal?: any;
  onChange?: (checked: boolean) => void;
}
export default function Toggle(props: ToggleProps) {
  const { register, errors, name, required, modalSubmit, labelName, defaultChecked, tabIndex, handleDisplayModal, setModalSubmit, displayModal, setChecked, setShowClickedSerial, showClickedSerial, onChange } = props
  const [isChecked, setIsChecked] = useState(defaultChecked);
  const handleToggleChange = () => {
    if (modalSubmit == false && isChecked == false) {
      handleDisplayModal(true);
    }
    else if (isChecked && showClickedSerial && displayModal==false) {
      setIsChecked(false)
      setShowClickedSerial(false)
      setModalSubmit(false)
    }
    // Remove the immediate toggle of the radio button
    else if (modalSubmit == false && isChecked == true && setChecked == true) {
      setShowClickedSerial(false);
      setIsChecked(false)
    }
    else{
      setIsChecked(!isChecked)
    }
    
    // Call the onChange prop if provided
    props.onChange?.(!isChecked);
  };

  useEffect(() => {
   
    if (setChecked === false) {
      setIsChecked(setChecked);
    }
    else if (modalSubmit) {
      setIsChecked(!isChecked)
    }
  }, [modalSubmit, defaultChecked, setChecked])


  const inputElement = register ? (
    <input
      {...register(name)}
      tabIndex={tabIndex}
      className="form-check-input cursor-pointer"
      type="checkbox"
      role="switch"
      id="flexSwitchCheckChecked"
      checked={isChecked}
      onChange={handleToggleChange}
    />
  ) : (
    <input
      tabIndex={tabIndex}
      className="form-check-input cursor-pointer"
      type="checkbox"
      role="switch"
      id="flexSwitchCheckChecked"
      checked={isChecked}
      onChange={handleToggleChange}
    />
  );
  return (
    <>
      <div className="form-check form-switch sidebar-toggler  ps-1">
        {inputElement}
        <label className="form-check-label">{labelName}</label>
      </div>
      {errors && (
        <div>
          <span className="text-danger"> {errors.message}</span>
        </div>
      )}
    </>
  );
}
